import AppService from './AppService';

export const IN_DEVELOPMENT_STATUS = 'inDevelopment';

const pending = new Map<string, Promise<string | null>>();

/**
 * The status of one app, fetched once per app per page load.
 *
 * The in-development banner remounts on every navigation inside an app, so
 * without the cache a single visit costs a request per screen. A failure
 * resolves to null and drops the cache entry: a status nobody could read must
 * not hide the app, and the next navigation gets a fresh attempt.
 */
export const fetchAppStatus = (appToken: string): Promise<string | null> => {
  const cached = pending.get(appToken);
  if (cached) return cached;

  const request = AppService.getAppStatus(appToken).catch(() => {
    pending.delete(appToken);
    return null;
  });
  pending.set(appToken, request);
  return request;
};
